import { HrmActions } from "../../pages/components/hrm_actions";

export const userListColumns = ({ onSelectAction }) => {
  return [
    {
      Header: "Sr. No.",
      accessor: "idd", // Assuming you set 'idd' correctly in the data
      Cell: ({ row }) => {
        return row.original.idd; // Return the idd value
      },
    },
    {
      Header: "Name",
      accessor: (row) => {
        return row?.name || "N/A";
      },
    },
    {
      Header: "Email",
      accessor: (row) => {
        return row?.email || "N/A";
      },
    },
    {
      Header: "Password",
      accessor: (row) => {
        return row?.password || "N/A";
      },
    },
    {
      Header: "Create user",
      accessor: (row) => {
        return row?.created_at || "N/A";
      },
    },
    // {
    //   Header: "Meta Description",
    //   // accessor: (row) => {
    //   //   return row?.meta_description || "N/A";
    //   // },
    //   accessor: (row) => {
    //     return (
    //       <><HrmActions
    //         onSelectAction={onSelectAction}
    //         row={row}
    //         view={true}
    //         datas={row?.meta_description}
    //       /></>
    //     );
    //   },
    // },
    {
      Header: "Actions",
      accessor: (row) => {
        return (
          <div className="text-left">
            <HrmActions
              onSelectAction={onSelectAction}
              row={row}
              isDefault={true}
            />
          </div>
        );
      },
    },
  ];
};
